import Constants from '../../../assests/Constants/constants';

/** Report endpoints may return the enum name instead of its number, so both resolve to the key. */
const enumKey = (enumObject, value) => (typeof value === 'number'
    ? Object.keys(enumObject).find((key) => enumObject[key] === value)
    : value || undefined);

export const statusKey = (status) => enumKey(Constants.StatusEnum, status);
export const priorityKey = (priority) => enumKey(Constants.PriorityEnum, priority);

const STATUS_TONES = { ToDo: 'warning', InProgress: 'info', Done: 'success' };
const PRIORITY_TONES = { High: 'warning', Critical: 'error' };

export const statusTone = (status) => STATUS_TONES[statusKey(status)];
export const priorityTone = (priority) => PRIORITY_TONES[priorityKey(priority)];

export const priorityEmoji = (priority) => Constants.PriorityEmojis[priorityKey(priority)] || '';
